import Card from '~/components/Card';
import Form from '~/components/Form';
import LineItem from '~/components/LineItem';
import LinkButton from '~/components/LinkButton';
import Page from '~/components/Page';
import Submit from '~/components/Submit';
import { useLoaderData } from './shopNowComplete';

export default function ShopNowCompletePage() {
  const { lineItems } = useLoaderData();

  return (
    <Page headline="Welcome Back - Shop Now Complete" hideHeader>
      <Card headline="Welcome Back! Does this look right?">
        <ul className="flex flex-col gap-4">
          {lineItems.map((item) => (
            <li key={item.gid}>
              <LineItem
                variant="small"
                name={item.title ?? 'N/A'}
                options={item.options ?? []}
                imgSrc={item.imgUrl}
                quantity={item.quantity}
              />
            </li>
          ))}
        </ul>
        <Form action="../../shop/start" className="flex flex-col gap-4">
          <LinkButton variant="filled" to="../../address" className="md:w-1/2">
            Continue
          </LinkButton>

          <Submit variant="text" name="action" value="removeItems">
            Remove items and shop again
          </Submit>
        </Form>
      </Card>
    </Page>
  );
}
